import { Controller } from '@hotwired/stimulus'

// Marketing flash/toast banner. Handles manual dismiss + auto-dismiss.
//
// Markup contract (see app/views/shared/_marketing_flash.html.haml):
//   <div class="mkt-flash mkt-flash--success" data-controller="mkt-flash"
//        data-mkt-flash-timeout-value="6000">
//     ...
//     <button data-action="mkt-flash#dismiss">×</button>
//   </div>
export default class extends Controller {
  static values = { timeout: { type: Number, default: 6000 } }

  connect() {
    // Slide in on next frame so the CSS transition runs.
    requestAnimationFrame(() => this.element.classList.add('is-visible'))

    if (this.timeoutValue > 0) {
      this._t = setTimeout(() => this.dismiss(), this.timeoutValue)
    }
  }

  dismiss() {
    clearTimeout(this._t)
    this.element.classList.remove('is-visible')
    this.element.classList.add('is-leaving')
    // Remove from the DOM after the transition completes.
    setTimeout(() => this.element.remove(), 350)
  }

  disconnect() {
    clearTimeout(this._t)
  }
}
